import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import { SharedAuditFacade } from '../+state/shared-audit.facade';
import { AuditScreen } from '../audit-screen.enum';

@Component({
  selector: 'sd-portal-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit {
  showAuditDrawer$: Observable<boolean>;
  @ViewChild('audits', { static: true }) auditsDrawer: MatDrawer;

  @Input() selectedAuditScreen: AuditScreen | null;
  auditScreen = AuditScreen;

  constructor(private readonly auditFacade: SharedAuditFacade) {}

  ngOnInit() {
    this.showAuditDrawer$ = this.auditFacade.showAuditDrawer$;
  }

  closeDrawer() {
    this.auditFacade.hideAuditDrawer();
  }

  drawerOpenChanged(isOpen: boolean) {
    if (!isOpen) {
      this.auditFacade.hideAuditDrawer();
    }
  }
}
